import { FC, useMemo } from 'react';
import { Colors, Typography } from '@altermaind/web/ui';
import { EventType } from '@/swagger/constants/credits-enums';

type Props = {
  value: number;
  eventType: EventType;
};

export const CreditViewValue: FC<Props> = ({ value, eventType }) => {
  const internalValue = useMemo((): { color: keyof Colors; label: string } => {
    switch (eventType) {
      case EventType.SURVEY:
        return {
          color: 'error',
          label: `-${value}`,
        };
      case EventType.MEDIA:
        return {
          color: 'error',
          label: `-${value}`,
        };
      case EventType.RECHARGE:
        return {
          color: 'success',
          label: `+${value}`,
        };
      case EventType.REWARD:
        return {
          color: 'success',
          label: `+${value}`,
        };
      case EventType.VIDEO:
        return {
          color: 'error',
          label: `-${value}`,
        };
      case EventType.QUIZ:
        return {
          color: 'error',
          label: `-${value}`,
        };
      default:
        return {
          color: 'primary/text',
          label: `${value}`,
        };
    }
  }, [value, eventType]);

  return (
    <Typography color={internalValue.color} variant='p2/light'>
      {internalValue.label}
    </Typography>
  );
};
